import { withChartLayout } from 'components/common';
import PsychiatricHistory from 'components/features/chart/provider-chart/history-physical/psychiatric-history/PsychiatricHistory';

const PsychiatricHistoryPage = withChartLayout('Psychiatric History')(PsychiatricHistory);
export default PsychiatricHistoryPage;
